import { SpectrumBankAccountStatus } from '../../../../common/enums/spectrumBankAccountEnum'

export const SPECTRUM_BANK_ACCOUNT_STATUS_BADGE: Record<
  SpectrumBankAccountStatus,
  { bg: string; color: string }
> = {
  [SpectrumBankAccountStatus.ACTIVE]: { bg: '#eefff4', color: '#00c051' },
  [SpectrumBankAccountStatus.INACTIVE]: { bg: '#fef3f2', color: '#f4483f' },
  [SpectrumBankAccountStatus.PENDING]: { bg: '#fffbeb', color: '#f59e0b' },
  [SpectrumBankAccountStatus.REJECTED]: { bg: '#fef3f2', color: '#f4483f' },
}
